import * as React from 'react';
import Eventservice from '../CalculationComponents/calculationComponents.eventservice';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { dialogueErrorButton, dialogueErrorBody } from 'sos-eservice-common/js/config/dialogueErrorBodies';
import { ESERVICE_MENU_SAVE_CLOSE } from 'sos-eservice-common/js/components/EServiceFormMenu/eservicemenu.actions';
import { SAVE_AND_CLOSE } from '../StatsbidragSubmitAction/StatsbidragSubmitAction';

export interface StatsbidragDialogueErrorProps {}

export interface StatsbidragDialogueErrorState {
  isModalOpen: boolean;
  dialogueErrorBody: dialogueErrorBody;
}

/**
 * Generic error modal that can be shown after different operations; whether success or fail.
 */
export class StatsbidragDialogueError extends React.Component<
  StatsbidragDialogueErrorProps,
  StatsbidragDialogueErrorState
> {
  constructor(props: StatsbidragDialogueErrorProps) {
    super(props);

    this.state = {
      isModalOpen: false,
      dialogueErrorBody: null,
    };
  }

  componentDidMount() {
    Eventservice.subscribe('dialogue-error', (e: CustomEvent) => {
      this.setState({
        isModalOpen: true,
        dialogueErrorBody: e.detail,
      });
    });
  }

  closeConfirm = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  doAction = (redirectUrl: string, action: string) => {
    this.closeConfirm();
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }

    if (action === ESERVICE_MENU_SAVE_CLOSE) {
      Eventservice.fire('form-submit-action', { detail: SAVE_AND_CLOSE });
    }
  };

  mapButtons = (btn: dialogueErrorButton) => {
    return (
      <button
        type="button"
        key={btn.text + Date.now().toString()}
        onClick={(_) => this.doAction(btn.redirectUrl, btn.action)}
        className={btn.cssClassNames}>
        {btn.text}
      </button>
    );
  };

  public render() {
    const { isModalOpen, dialogueErrorBody } = this.state;

    return (
      <Dialog isOpen={isModalOpen} onRequestClose={this.closeConfirm}>
        <button type="button" onClick={this.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>

        {dialogueErrorBody && (
          <React.Fragment>
            {dialogueErrorBody.body}
            <div className="footer">{dialogueErrorBody.buttons.map(this.mapButtons)}</div>
          </React.Fragment>
        )}
      </Dialog>
    );
  }
}
